import { render, staticRenderFns } from "./LaboratoryCities.vue?vue&type=template&id=1a31f714&scoped=true"
import script from "./LaboratoryCities.vue?vue&type=script&lang=js"
export * from "./LaboratoryCities.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryCities.vue?vue&type=style&index=0&id=1a31f714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a31f714",
  null
  
)

export default component.exports